import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'BLITZ',
    description: "BLITZ is a creative marketing agency. We build bold brands, creative campaigns and marketing strategies that turn attention into measurable business growth.",
    placeholder: "Marketing for a brighter tomorrow.",
    url: getOrigin()
}

export const TAGLINE = "Marketing for a brighter tomorrow."

/*
 * Editable business details. Change a value here and it updates in the footer and on the contact page.
 * Leave a value empty ('') to hide it until it is ready.
 */
export const CONTACT = {
    email: 'hello@prj-xek8y6p7n0qxl9.modulify.website',
    phone: '',
    location: "Remote-first, working worldwide"
}

/* Social profiles. A profile only appears on the site once its address is filled in. */
export const SOCIALS: { label: string, url: string }[] = [
    { label: 'LinkedIn', url: '' },
    { label: 'Instagram', url: '' },
    { label: 'Behance', url: '' }
]
